import { Slider } from "primereact/slider";

import GraficoPrevisao from "./GraficoPrevisao";
import TabelaPrevisao from "../../Tabelas/TabelaPrevisao";

const SuavizacaoExponencial = ({ alpha, setAlpha, series, futureLabels, forecast, available }) => (
  <>
    <div className="p-field p-mb-4" style={{ maxWidth: 420 }}>
      <label>Fator alfa: {alpha.toFixed(1)}</label>
      <Slider min={0.1} max={0.9} step={0.1} value={alpha} onChange={(event) => setAlpha(event.value)} />
    </div>
    <p>Alfa alto reage mais rapidamente às variações; alfa baixo suaviza os ruídos.</p>
    {available ? (
      <>
        <GraficoPrevisao
          series={series}
          futureLabels={futureLabels}
          methods={[{ key: "exponential", method: forecast }]}
        />
        <TabelaPrevisao
          series={series}
          futureLabels={futureLabels}
          methods={[{ key: "exponential", method: forecast }]}
        />
      </>
    ) : null}
  </>
);

export default SuavizacaoExponencial;
